module.exports = __webpack_public_path__ + "img/point_icon.cff7ce70.svg";